module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "corporatecommunity"
  }, [(_vm.associatedCorporation) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "smallimgholder"
  }, [(_vm.associatedCorporation.smallImage) ? _c('img', {
    attrs: {
      "src": _vm.associatedCorporation.smallImage,
      "alt": "CORP IMAGE",
      "title": _vm.associatedCorporation.name
    }
  }) : _vm._e(), _c('div', {
    staticClass: "hidemobile"
  }, [_c('br'), _vm._v(" "), _c('b', [_vm._v(" " + _vm._s(_vm.associatedCorporation.pageWelcomeMessage))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/toneApp.png"),
      "alt": "APP QR CODE",
      "text": "APP QR Code"
    }
  }), _c('br'), _vm._v(" " + _vm._s(_vm.associatedCorporation.pageWelcomeMessage) + "Scan the QR code to download our app and enjoy Tone on the go!\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 margin-bottom-40"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('ul', [(_vm.associatedCorporation.showSpotlightSection || _vm.associatedCorporation.showPinnedMessages) ? _c('li', {
    staticClass: "community",
    class: {
      current: _vm.selectedTab === 'community'
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('community')
      }
    }
  }, [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "aria-pressed": (_vm.selectedTab === 'community') ? 'true' : 'false'
    }
  }, [_vm._v("Community")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "events",
    class: {
      current: _vm.selectedTab === 'events'
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('events')
      }
    }
  }, [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "aria-pressed": (_vm.selectedTab === 'events') ? 'true' : 'false'
    }
  }, [_c('span', {
    staticClass: "hidemobile"
  }, [_vm._v("Career")]), _vm._v(" Coaching")])]), _vm._v(" "), (_vm.getCorpPrivateVideos) ? _c('li', {
    staticClass: "events",
    class: {
      current: _vm.selectedTab === 'videos'
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('videos')
      }
    }
  }, [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "aria-pressed": (_vm.selectedTab === 'videos') ? 'true' : 'false'
    }
  }, [_vm._v(" Videos")])]) : _vm._e(), _vm._v(" "), (_vm.getCorpPlaylists) ? _c('li', {
    staticClass: "playlists",
    class: {
      current: _vm.selectedTab === 'playlists'
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('playlists')
      }
    }
  }, [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "aria-pressed": (_vm.selectedTab === 'playlists') ? 'true' : 'false'
    }
  }, [_vm._v("Playlists")])]) : _vm._e()])]), _vm._v(" "), (_vm.selectedTab === 'community') ? _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.community
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [(_vm.associatedCorporation.showSpotlightSection) ? _c('div', {
    staticClass: "row video-row introparacard"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.associatedCorporation.spotlightPic) ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('img', {
    attrs: {
      "src": _vm.associatedCorporation.spotlightPic,
      "alt": "SPOTLIGHT IMAGE",
      "title": "In Spotlight"
    }
  })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [(_vm.associatedCorporation.spotlightPara1) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.associatedCorporation.spotlightPara1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.associatedCorporation.spotlightPara2) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.associatedCorporation.spotlightPara2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.associatedCorporation.spotlightPara3) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.associatedCorporation.spotlightPara3)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.associatedCorporation.spotlightQuote) ? _c('blockquote', [_vm._v("\"" + _vm._s(_vm.associatedCorporation.spotlightQuote) + "\"")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr', {
    staticClass: "redhr"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getCorporationPinnedMsgs && (_vm.associatedCorporation.showPinnedMessages || _vm.associatedCorporation.showPinnedMessages === 1)) ? _c('div', {
    staticClass: "pinnedmsgs"
  }, [(_vm.associatedCorporation.pinnedMessageHeading) ? _c('h3', [_vm._v(_vm._s(_vm.associatedCorporation.pinnedMessageHeading) + " "), _c('i', {
    staticClass: "fa fa-map-pin ",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._l((_vm.getCorporationPinnedMsgs), function(msg) {
    return _c('div', {
      staticClass: "borderedbox"
    }, [_c('h4', [_vm._v(_vm._s(msg.msgSenderName) + " "), _c('small', [_vm._v(_vm._s(msg.msgSentDateFmt))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(msg.corpAdminMessage))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'events') ? _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.events
    },
    attrs: {
      "id": "tabs-2"
    }
  }, [(_vm.getCorpMainEvent) ? _c('div', {
    staticClass: "row video-row"
  }, [_c('h3', [_c('b', [_vm._v("Join " + _vm._s(_vm.associatedCorporation.name) + " and TONE Networks for Event this " + _vm._s(_vm.getDateReference(_vm.getCorpMainEvent.start_date, 'str')))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [_c('div', [_c('h3', [_vm._v("Choose how you want to join the event. You can join as yourself or step into someone else's shoes using our anonymous shoe-cognito mode")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "title": "Join event"
    },
    on: {
      "click": function($event) {
        return _vm.generateUnAuthTokenAndRedirect('0')
      }
    }
  }, [_vm._v("Jane")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "title": "Join event"
    },
    on: {
      "click": function($event) {
        return _vm.generateUnAuthTokenAndRedirect('1')
      }
    }
  }, [_vm._v("Shoe-Incognito")]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 imgresponsive"
  }, [_c('img', {
    attrs: {
      "src": _vm.getCorpMainEvent.img_url,
      "alt": "CORP MAIN EVENT BANENR",
      "title": _vm.getCorpMainEvent.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-left large-text"
  }, [_c('h3', [_vm._v(_vm._s(_vm.getCorpMainEvent.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCorpMainEvent.longDescription))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDateReference(_vm.getCorpMainEvent.start_date, 'str')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), (_vm.getCorpPrivateEvents && _vm.getCorpPrivateEvents.length >= 2) ? _c('div', {
    staticClass: "row"
  }, [_c('h3', [_c('b', [(_vm.associatedCorporation.privateEventHeading) ? _c('h3', [_c('b', [_vm._v(_vm._s(_vm.associatedCorporation.privateEventHeading))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 imgresponsive large-text text-left"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getCorpPrivateEvents[0].img_url,
      "alt": "PRIVATE EVENT BANNER",
      "title": _vm.getCorpPrivateEvents[0].title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].longDescription))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDateReference(_vm.getCorpPrivateEvents[0].start_date, 'str')))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.getCorpPrivateEvents[0].eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    attrs: {
      "title": "Add to Calendar"
    }
  }, [_vm._v("\n                                        Add to Calendar\n                                        "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.getCorpPrivateEvents[0].type === '1') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[0].type === '2') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[0].type === '3') ? _c('span', [_vm._v(_vm._s(_vm.associatedCorporation.name) + "'s Self-Hosted Event")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 imgresponsive large-text text-left"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getCorpPrivateEvents[1].img_url,
      "alt": "PRIVATE EVENT BANNER",
      "title": _vm.getCorpPrivateEvents[1].title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].longDescription))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDateReference(_vm.getCorpPrivateEvents[1].start_date, 'str')))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.getCorpPrivateEvents[1].eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    attrs: {
      "title": "Add to Calendar"
    }
  }, [_vm._v("\n                                        Add to Calendar\n                                        "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.getCorpPrivateEvents[0].type === '1') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[0].type === '2') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[1].type === '3') ? _c('span', [_vm._v(_vm._s(_vm.associatedCorporation.name) + "'s Self-Hosted Event")]) : _vm._e()])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents && _vm.getCorpPrivateEvents.length === 1) ? _c('div', {
    staticClass: "row"
  }, [_c('h3', [_c('b', [(_vm.associatedCorporation.privateEventHeading) ? _c('h3', [_c('b', [_vm._v(_vm._s(_vm.associatedCorporation.privateEventHeading))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 m-auto imgresponsive large-text text-left"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getCorpPrivateEvents[0].img_url,
      "alt": "PRIVATE EVENT BANNER",
      "title": _vm.getCorpPrivateEvents[0].title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].longDescription))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDateReference(_vm.getCorpPrivateEvents[0].start_date, 'str')))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.getCorpPrivateEvents[0].eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    attrs: {
      "title": "Add to Calendar"
    }
  }, [_vm._v("\n                                        Add to Calendar\n                                        "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.getCorpPrivateEvents[0].type === '1') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[0].type === '2') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[0].type === '3') ? _c('span', [_vm._v(_vm._s(_vm.associatedCorporation.name) + "'s Self-Hosted Event")]) : _vm._e()])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "50px",
      "border-bottom": "3px solid #cbcbcb",
      "margin-bottom": "30px"
    }
  }), _vm._v(" "), (_vm.getCorpPublicEvents) ? _c('div', {
    staticClass: "sliderEventBox"
  }, [(_vm.associatedCorporation.toneEventHeading) ? _c('h2', [_vm._v(_vm._s(_vm.associatedCorporation.toneEventHeading))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.getCorpPublicEvents), function(ev) {
    return _c('div', {
      staticClass: "col-sm-4"
    }, [_c('h2', {
      staticClass: "carosalh2",
      staticStyle: {
        "color": "#f0617d"
      }
    }, [(ev.type === '1') ? _c('span', [_vm._v(" TONE Live\n")]) : _c('span', [_vm._v(" TONE Talk")])]), _vm._v(" "), _c('img', {
      staticClass: "sliderimage",
      attrs: {
        "src": ev.img_url,
        "alt": "PUBLIC EVENT BANNER",
        "title": ev.title
      }
    }), _vm._v(" "), _c('h2', [_c('a', {
      attrs: {
        "href": '/event/' + ev.eventId,
        "target": "new"
      }
    }, [_vm._v(_vm._s(_vm.getDateReference(ev.start_date, 'live')) + ":  " + _vm._s(_vm.getExpertInfo(ev.expertId, 'name')))])]), _vm._v(" "), _c('p', [_vm._v("\n                                            " + _vm._s(ev.longDescription) + "\n                                        ")]), _vm._v(" "), _c('h5', [_vm._v("LIVE " + _vm._s(_vm.getDateReference(ev.start_date, 'live2')))]), _vm._v(" "), (!_vm.showJoin(ev.eventId)) ? _c('div', {
      staticClass: "addeventatc pinkoutlinebtn",
      attrs: {
        "title": "Add to Calendar"
      }
    }, [_vm._v("\n                                            Add to Calendar\n                                            "), _c('span', {
      staticClass: "start"
    }, [_vm._v(_vm._s(ev.start_date))]), _vm._v(" "), _c('span', {
      staticClass: "end"
    }, [_vm._v(_vm._s(ev.end_date))]), _vm._v(" "), _c('span', {
      staticClass: "timezone"
    }, [_vm._v("ev/New_York")]), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(ev.title))]), _vm._v(" "), _c('span', {
      staticClass: "description"
    }, [_vm._v(_vm._s(ev.longDescription))]), _vm._v(" "), _c('span', {
      staticClass: "location"
    }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(ev.eventId))])]) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.getCorpArchiveEvents) ? _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "50px",
      "border-bottom": "3px solid #cbcbcb",
      "margin-bottom": "30px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getCorpArchiveEvents) ? _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.associatedCorporation.archiveEventHeading) ? _c('h3', [_c('strong', [_vm._v(_vm._s(_vm.associatedCorporation.archiveEventHeading))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getCorpArchiveEvents) ? _c('div', {
    staticClass: "clearfix"
  }) : _vm._e(), _vm._v(" "), (_vm.getCorpArchiveEvents) ? _c('div', {
    staticClass: "sliderEventBox pointer"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.getCorpArchiveEvents), function(evn) {
    return _c('div', {
      staticClass: "col-sm-4",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('img', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      staticClass: "sliderimage",
      attrs: {
        "aria-label": evn.title,
        "src": evn.img_url,
        "alt": "PRIVATE EVENT BANNER",
        "title": evn.title
      },
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }), _vm._v(" "), _c('h2', [_c('button', {
      staticClass: "tone-heading-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }, [_vm._v(_vm._s(evn.title))])]), _vm._v(" "), _c('p', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }, [_vm._v("\n                                                " + _vm._s(evn.longDescription) + "\n\n                                            ")])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "50px",
      "border-bottom": "1px solid #ddd"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'videos') ? _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.videos
    },
    attrs: {
      "id": "tabs-3"
    }
  }, [(_vm.associatedCorporation.videoTabHeading) ? _c('h3', [_c('b', [_vm._v(_vm._s(_vm.associatedCorporation.videoTabHeading))])]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, _vm._l((_vm.getCorpPrivateVideos), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                                                 " + _vm._s(video.title) + "\n                                             ")])])])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'playlists') ? _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.playlists
    },
    attrs: {
      "id": "tabs-4"
    }
  }, [(_vm.getCorpPlaylists) ? _c('div', {
    staticClass: "row video-row plistisrow"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.associatedCorporation.playlistHeading) ? _c('h2', [_vm._v(_vm._s(_vm.associatedCorporation.playlistHeading))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  })]), _vm._v(" "), _vm._l((_vm.getCorpPlaylists), function(playlist) {
    return (playlist.userPlaylistVideos) ? _c('div', [_c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 "
    }, [(playlist.userPlaylistVideos && playlist.userPlaylistVideos.length > 0) ? _c('div', {
      staticClass: "pinkbg"
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": playlist.userPlaylistVideos[0].thumbnailURL,
        "alt": playlist.title,
        "title": playlist.title
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "pinksidebarmin"
    }, [_c('span', {
      staticClass: "numb"
    }, [_c('strong', [_vm._v(_vm._s(playlist.userPlaylistVideos.length))])]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      staticClass: "fa fa-envelope-o",
      attrs: {
        "aria-label": "Share Playlist",
        "title": "Share Playlist"
      },
      on: {
        "click": function($event) {
          return _vm.openCorporateShareModal(playlist)
        }
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 pltext"
    }, [_c('h3', [_c('button', {
      staticClass: "tone-heading-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }, [_vm._v(_vm._s(playlist.title))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(playlist.description))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix",
      staticStyle: {
        "height": "10px"
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.getCropUserSharedVideos) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('hr', {
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Here are all videos shared with you by your colleagues")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "50px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row  video-row plistisrow lowerlist"
  }, _vm._l((_vm.getCropUserSharedVideos), function(video) {
    return _c('div', {
      staticClass: "col-sm-6"
    }, [_c('div', {
      staticClass: "videoholdersuggestions"
    }, [_c('img', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      attrs: {
        "aria-label": video.videoTitle,
        "src": video.thumbnailURL,
        "alt": video.videoTitle,
        "title": video.videoTitle
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(video.videoCode)
        }
      }
    }), _vm._v(" "), _c('h3', [_c('button', {
      staticClass: "tone-heading-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(video.videoCode)
        }
      }
    }, [_vm._v(_vm._s(video.videoTitle))])]), _vm._v(" "), _c('p', [_vm._v("Shared by " + _vm._s(video.senderName))]), _vm._v(" "), _c('p', [_vm._v("Message: " + _vm._s(video.messageText))])])])
  }), 0)]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.showCorporateShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Share This Playlist\n                "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    attrs: {
      "aria-label": "Share with"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")])])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "aria-label": "Corporate recipients",
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg",
      "alt": "user-shoe"
    }
  })]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Jane")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "aria-label": "Type your message",
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.corpShareModalImage,
      "alt": _vm.corpShareModalTitle,
      "title": _vm.corpShareModalTitle
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s((_vm.corpShareModalTitle + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.corpShareModalDesc.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    attrs: {
      "disabled": _vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0)
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateVideo()
      }
    }
  }, [_vm._v("\n                            Share This Playlist\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as Jane\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n                                            Please follow the event guidelines:\n                                            "), _c('span', [_vm._v("1.)")]), _vm._v(" Keep it positive, supportive and respectful;\n                                            "), _c('span', [_vm._v("2.)")]), _vm._v(" Please be thoughtful and stay on topic;\n                                            "), _c('span', [_vm._v("3.)")]), _vm._v(" Please do not post copyrighted material, ads, solicitations or anyone's personal info including your own;\n                                            "), _c('span', [_vm._v("4.)")]), _vm._v(" Please refer to TONE's "), _c('a', {
    attrs: {
      "href": "/terms",
      "target": "new",
      "title": "click to view our terms"
    }
  }, [_vm._v("Terms of Service")]), _vm._v(" for more information.\n                                        ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7ea4666d", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ea4666d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/CommunityDemo.vue